{
  "mailValidator": "Type in a valid e-mail.",
  "binoMailForbidden": "You cannot register with your BI email address. Please use your private email.",
  "email": "Private email",
  "password1": "Password",
  "password2": "Verify password",
  "password1Validator": "Minimum 12 letters, numbers or special characters",
  "password2Validator": "Passwords do not match",
  "login": "Login to StudentPortal",
  "reqTitle": "The password must have:",
  "newPasswordReq1": "Minimum 12 characters",
  "newPasswordReq2": "May contain",
  "newPasswordReq2a": "Upper and lower case letters",
  "newPasswordReq2b": "Numbers and special characters (!@#$%^&*)",
  "TryAgainLink": "Click here to try again"
}
